import { faqs } from '../../data/landingData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

export const FAQ = () => {
  return (
    <section 
      id="faq" 
      className="py-24 px-6 bg-[#0A0A0A]"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
            Questions?
          </p>
          <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#111111] border border-white/5 rounded-xl px-6 data-[state=open]:border-[#D4AF37]/30"
              data-testid={`faq-${index}`}
            >
              <AccordionTrigger className="text-left font-manrope font-medium text-white hover:text-[#D4AF37] hover:no-underline py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 font-manrope pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="text-zinc-500 font-manrope mb-4">
            Still have questions?
          </p>
          <a
            href="mailto:askcoachneil@gmail.com"
            className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#B8860B] font-manrope font-medium transition-colors"
            data-testid="contact-email"
          >
            Contact us at askcoachneil@gmail.com
          </a>
        </div>
      </div>
    </section>
  );
};
